import PostRateonLearningGoals from "./PostRateonLearningGoals";
export default PostRateonLearningGoals;
